// extracted by mini-css-extract-plugin
module.exports = {"formSection":"Contacto_formSection__aejaK","content":"Contacto_content__1mSSS","formGroup":"Contacto_formGroup__3GeHz","btn":"Contacto_btn__1acpM"};